export default __webpack_public_path__ + "static/media/taxiarmenia.3cc3f782.png";